import { AppDispatch } from "../../store";
import { siteContextRequest } from "../../redux/siteContextRequest";
import config from "../../config";

export const requestGcpSuggestion = (
  customerId: string,
  siteId: string,
) => async (dispatch: AppDispatch): Promise<void> => {
  await dispatch(
    siteContextRequest(customerId, siteId, {
      method: "POST",
      url: `${config.endpoints.backofficeWebService}/api/customer/${customerId}/site/${siteId}/request-gcp-suggestion`,
    }),
  );
};
